import { render } from "./SaferPay.vue?vue&type=template&id=4172f978"
import script from "./SaferPay.vue?vue&type=script&lang=js"
export * from "./SaferPay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__